export default function Logo({className}: { className?: string }) {
    return <>
        <div className="flex justify-center items-center">
            <img className={`max-w-xs ${className || ''}`} src={process.env.PUBLIC_URL + 'images/logo/logo-treffpunkt-zur-guten-quelle.svg'} alt={'Logo - Zur guten Quelle'}/>
        </div>
    </>
}